// extracted by mini-css-extract-plugin
export default {"recos":"X7-z","productCardOverride":"Y7-z","rowHasBadge":"Z7-z"};